/** ANC_HUB_FACTORY / FABRICANT_ANC */
export const FABRICANT_ANC_CATEGORY = 65534;

export const PRESTATAIRE_TYPES = ['MISE_EN_SERVICE', 'ENTRETIEN', 'REPARATION'] as const;
export type PrestataireTypeValue = (typeof PRESTATAIRE_TYPES)[number];

/** ANC Hub OTHERS company categories (prestataire sub-types). */
export const ANC_HUB_OTHERS_CATEGORY = 32767;
export const ANC_HUB_OTHERS_INSTALLER_CATEGORY = 32768;
export const ANC_HUB_OTHERS_MAINTAINER_CATEGORY = 32769;

/** Sub-type categories a new prestataire company gets for each "Type de prestation". */
export const PRESTATAIRE_TYPE_CATEGORIES: Record<PrestataireTypeValue, number[]> = {
    MISE_EN_SERVICE: [ANC_HUB_OTHERS_MAINTAINER_CATEGORY, ANC_HUB_OTHERS_INSTALLER_CATEGORY],
    ENTRETIEN: [ANC_HUB_OTHERS_MAINTAINER_CATEGORY, ANC_HUB_OTHERS_INSTALLER_CATEGORY],
    REPARATION: [ANC_HUB_OTHERS_MAINTAINER_CATEGORY, ANC_HUB_OTHERS_INSTALLER_CATEGORY],
};

export const HOMOLOGATION_MEDIA_TAG = 'homologation';
